// extracted by mini-css-extract-plugin
export var calendar = "index-module--calendar--23698";
export var calendarDay = "index-module--calendarDay--52558";
export var calendarInline = "index-module--calendarInline--cb032";
export var calendarMonth = "index-module--calendarMonth--140f2";
export var table = "index-module--table--b3e06";
export var tableWrapper = "index-module--tableWrapper--984fc";